const a3PaySetupRu: Record<string, string> = {
  "a3PaySetup.a11y.paymentAccountSummary": "Сводка платежных аккаунтов",
  "a3PaySetup.a11y.providersAndMethods": "Провайдеры и способы оплаты",
  "a3PaySetup.a11y.headerActions": "Действия платежного аккаунта",
  "a3PaySetup.a11y.stickyNextAction": "Следующее действие настройки",
  "a3PaySetup.actions.activate": "Активировать",
  "a3PaySetup.actions.apply": "Применить",
  "a3PaySetup.actions.check": "Проверить",
  "a3PaySetup.actions.configureMethods": "Настроить способы",
  "a3PaySetup.actions.connectProvider": "Подключить провайдера",
  "a3PaySetup.actions.continueSetup": "Продолжить настройку",
  "a3PaySetup.actions.deletePreference": "Удалить настройку",
  "a3PaySetup.actions.load": "Загрузить",
  "a3PaySetup.actions.manageReceiptSettings": "Управлять настройками чеков",
  "a3PaySetup.actions.moreActions": "Больше действий",
  "a3PaySetup.actions.notMine": "Не мой",
  "a3PaySetup.actions.openDisputes": "Открыть споры",
  "a3PaySetup.actions.openExport": "Открыть экспорт",
  "a3PaySetup.actions.openPayments": "Открыть платежи",
  "a3PaySetup.actions.openPayouts": "Открыть выплаты",
  "a3PaySetup.actions.openReceipts": "Открыть чеки",
  "a3PaySetup.actions.openReconciliation": "Открыть проблемы сопоставления",
  "a3PaySetup.actions.openRefunds": "Открыть возвраты",
  "a3PaySetup.actions.refresh": "Обновить",
  "a3PaySetup.actions.rollback": "Откатить",
  "a3PaySetup.actions.save": "Сохранить",
  "a3PaySetup.actions.saveDraft": "Сохранить черновик",
  "a3PaySetup.actions.send": "Отправить",
  "a3PaySetup.actions.setProviderAccount": "Настроить аккаунт провайдера",
  "a3PaySetup.actions.showTechnicalDetails": "Показать технические детали",
  "a3PaySetup.actions.testTableServicePayment": "Проверить платеж Table Service",
  "a3PaySetup.actions.trace": "Отследить",
  "a3PaySetup.actions.updateAccountData": "Обновить данные аккаунтов",
  "a3PaySetup.common.a3Pay": "A3 Pay",
  "a3PaySetup.common.accountConnected": "Аккаунт подключен",
  "a3PaySetup.common.accountNotConnected": "Не подключен",
  "a3PaySetup.common.actionNeeded": "Нужно действие",
  "a3PaySetup.common.amount": "Сумма",
  "a3PaySetup.common.available": "Доступно",
  "a3PaySetup.common.blocked": "Заблокировано",
  "a3PaySetup.common.canChangeData": "Можно менять данные",
  "a3PaySetup.common.channel": "Канал",
  "a3PaySetup.common.checking": "Проверка",
  "a3PaySetup.common.currency": "Валюта",
  "a3PaySetup.common.deleted": "Удалено",
  "a3PaySetup.common.email": "Email",
  "a3PaySetup.common.enabled": "Включено",
  "a3PaySetup.common.inProgress": "В процессе",
  "a3PaySetup.common.loadingSettings": "Загрузка настроек",
  "a3PaySetup.common.merchant": "Мерчант",
  "a3PaySetup.common.notCompleted": "Не завершено",
  "a3PaySetup.common.notRecordedYet": "Пока не записано",
  "a3PaySetup.common.off": "Выключено",
  "a3PaySetup.common.optional": "необязательно",
  "a3PaySetup.common.order": "Заказ",
  "a3PaySetup.common.paid": "Оплачено",
  "a3PaySetup.common.paymentReference": "Ссылка на платеж",
  "a3PaySetup.common.privateLink": "Приватная ссылка",
  "a3PaySetup.common.productConsole": "Консоль продукта",
  "a3PaySetup.common.readOnly": "Только чтение",
  "a3PaySetup.common.ready": "Готово",
  "a3PaySetup.common.receiptSettings": "Настройки чеков",
  "a3PaySetup.common.recentlyUpdated": "Недавно обновлено",
  "a3PaySetup.common.reference": "Ссылка",
  "a3PaySetup.common.secureCheckout": "Безопасная оплата",
  "a3PaySetup.common.status": "Статус",
  "a3PaySetup.common.updated": "Обновлено",
  "a3PaySetup.common.updatedAt": "Обновлено {value}",
  "a3PaySetup.common.version": "Версия",
  "a3PaySetup.dates.notUpdatedYet": "Пока не обновлялось",
  "a3PaySetup.diagnostics.evidenceExport.description": "Экспорт платежных запросов, событий, инструкций по выплатам, записей защищенных средств, выплат, проверок и доказательств по терминалам.",
  "a3PaySetup.diagnostics.evidenceExport.title": "Экспорт доказательств",
  "a3PaySetup.diagnostics.rawStatusDetails": "Технические детали статуса",
  "a3PaySetup.errors.loadPaymentAccounts": "Не удалось загрузить статус платежных аккаунтов",
  "a3PaySetup.errors.loadMerchantReadiness": "Не удалось загрузить готовность мерчанта",
  "a3PaySetup.errors.loadProductionReadiness": "Не удалось загрузить готовность к production",
  "a3PaySetup.errors.loadRegistry": "Не удалось загрузить записи Core Registry",
  "a3PaySetup.errors.merchantRequired": "Мерчант обязателен.",
  "a3PaySetup.errors.loadReceiptPreference": "Эта ссылка на настройки чеков больше недоступна.",
  "a3PaySetup.errors.loadTemplates": "Не удалось загрузить шаблоны",
  "a3PaySetup.errors.loadTrace": "Не удалось загрузить трассировку A3 Pay",
  "a3PaySetup.errors.paymentAccountRetry": "Статус платежных аккаунтов нужно проверить еще раз",
  "a3PaySetup.errors.paymentNotFound": "Платеж не найден.",
  "a3PaySetup.errors.paymentStatusUnavailable": "Статус платежа временно недоступен.",
  "a3PaySetup.errors.productionReadinessFailed": "Проверка готовности не удалась",
  "a3PaySetup.errors.receiptCouldNotSend": "Сейчас чек отправить не удалось.",
  "a3PaySetup.errors.receiptPreferenceDeletedFailed": "Сейчас настройки чеков удалить не удалось.",
  "a3PaySetup.errors.receiptPreferenceSaveFailed": "Сейчас настройки чеков сохранить не удалось.",
  "a3PaySetup.errors.receiptPreferenceUpdateFailed": "Сейчас настройки чеков обновить не удалось.",
  "a3PaySetup.errors.registryFailed": "Действие в реестре не удалось",
  "a3PaySetup.errors.saveProviderAccount": "Не удалось сохранить аккаунт провайдера",
  "a3PaySetup.errors.saveRegistry": "Не удалось сохранить запись Core Registry",
  "a3PaySetup.errors.saveTemplate": "Не удалось сохранить шаблон",
  "a3PaySetup.errors.technicalMessage": "Техническое сообщение",
  "a3PaySetup.errors.technicalTimestamp": "Время",
  "a3PaySetup.errors.templateMerchantRequired": "Ссылка на мерчанта обязательна.",
  "a3PaySetup.errors.traceRetry": "Трассировку нужно попробовать еще раз",
  "a3PaySetup.errors.tryAgainBody": "Попробуйте еще раз. Если это повторится, обратитесь в поддержку. Технические детали скрыты ниже.",
  "a3PaySetup.errors.updateAccountData": "Не удалось обновить данные платежных аккаунтов",
  "a3PaySetup.forms.changeEmail": "Изменить email",
  "a3PaySetup.forms.directoryMerchant": "Мерчант в директории",
  "a3PaySetup.forms.directoryRef": "Ссылка директории",
  "a3PaySetup.forms.enableA3Pay": "Включить A3 Pay",
  "a3PaySetup.forms.enterPaymentReference": "Введите ссылку на платеж",
  "a3PaySetup.forms.html": "HTML",
  "a3PaySetup.forms.locale": "Локаль",
  "a3PaySetup.forms.merchantRef": "Ссылка на мерчанта",
  "a3PaySetup.forms.merchantIdPlaceholder": "id мерчанта",
  "a3PaySetup.forms.optionalPlaceholder": "необязательно",
  "a3PaySetup.forms.paymentProviderAccount": "Аккаунт провайдера",
  "a3PaySetup.forms.providerAccountPlaceholder": "acct_...",
  "a3PaySetup.forms.paymentReferencePlaceholder": "id платежа, idempotency key, id платежа у провайдера",
  "a3PaySetup.forms.paymentRequestRef": "Ссылка на платежный запрос",
  "a3PaySetup.forms.replyTo": "Ответить на",
  "a3PaySetup.forms.senderEmail": "Email отправителя",
  "a3PaySetup.forms.senderName": "Имя отправителя",
  "a3PaySetup.forms.sourceMerchantRef": "Ссылка на мерчанта",
  "a3PaySetup.forms.subject": "Тема",
  "a3PaySetup.forms.text": "Текст",
  "a3PaySetup.header.navigationLabel": "Навигация {productName}",
  "a3PaySetup.header.payTagline": "Операции онлайн-платежей registered PI",
  "a3PaySetup.nav.acceptance": "Прием платежей",
  "a3PaySetup.nav.accounts": "Аккаунты",
  "a3PaySetup.nav.acquirer": "Терминальные расчеты",
  "a3PaySetup.nav.disputes": "Споры",
  "a3PaySetup.nav.evidence": "Доказательства",
  "a3PaySetup.nav.merchants": "Мерчанты",
  "a3PaySetup.nav.operations": "Операции",
  "a3PaySetup.nav.payments": "Платежи",
  "a3PaySetup.nav.readiness": "Готовность",
  "a3PaySetup.nav.receiptEmails": "Email-чеков",
  "a3PaySetup.nav.receipts": "Чеки",
  "a3PaySetup.nav.reconciliation": "Сопоставление платежей",
  "a3PaySetup.nav.registry": "Реестр",
  "a3PaySetup.nav.remittance": "Выплаты",
  "a3PaySetup.nav.risk": "Риски",
  "a3PaySetup.nav.riskDisputes": "Риски и споры",
  "a3PaySetup.nav.safeguarding": "Защищенные средства",
  "a3PaySetup.nav.safeguardingReconciliation": "Safeguarding и сверка",
  "a3PaySetup.nav.settlementRemittance": "Расчеты и выплаты",
  "a3PaySetup.nav.supportDiagnostics": "Диагностика поддержки",
  "a3PaySetup.nav.trace": "Трассировка",
  "a3PaySetup.notices.accountDataRefreshed": "Данные аккаунтов обновлены",
  "a3PaySetup.notices.paymentAccountDataAlreadyCurrent": "Данные платежных аккаунтов уже актуальны.",
  "a3PaySetup.notices.paymentAccountDataUpdated_one": "Данные платежных аккаунтов обновлены для {count} записи.",
  "a3PaySetup.notices.paymentAccountDataUpdated_other": "Данные платежных аккаунтов обновлены для {count} записей.",
  "a3PaySetup.notices.providerAccountSavedEnabled": "Аккаунт провайдера сохранен в A3 Pay и включен для выбранной оплаты.",
  "a3PaySetup.notices.providerAccountSavedShared": "Аккаунт провайдера сохранен в A3 Pay для общей настройки платежей.",
  "a3PaySetup.notices.receiptAutomaticOff": "Автоматические чеки отключены.",
  "a3PaySetup.notices.receiptAlreadyRequested": "Этот чек уже запрашивали. Повторное письмо не отправлено.",
  "a3PaySetup.notices.receiptEmailQueued": "Email с чеком поставлен в очередь.",
  "a3PaySetup.notices.receiptFiscalPending": "Платеж завершен. Фискальный чек еще готовится, поэтому email будет отправлен позже.",
  "a3PaySetup.notices.receiptPreferenceDeleted": "Эта настройка чека удалена.",
  "a3PaySetup.notices.receiptSettingsSaved": "Настройки чеков сохранены.",
  "a3PaySetup.notices.receiptTryLater": "Email с чеком недавно уже запрашивали. Попробуйте позже, если он не придет.",
  "a3PaySetup.notices.receiptsAvailableAfterPayment": "Чек доступен после завершения платежа.",
  "a3PaySetup.notices.validEmailRequired": "Введите корректный email, если хотите получить чек по email.",
  "a3PaySetup.merchantReadiness.blockingLabel": "Блокируют",
  "a3PaySetup.merchantReadiness.blockingWarnings": "{blocking} блокируют, {warnings} предупреждений",
  "a3PaySetup.merchantReadiness.cards.gates": "Гейты готовности",
  "a3PaySetup.merchantReadiness.cards.merchant": "Мерчант",
  "a3PaySetup.merchantReadiness.cards.onlinePayments": "Онлайн-платежи",
  "a3PaySetup.merchantReadiness.cards.owner": "Владеющая Party",
  "a3PaySetup.merchantReadiness.description": "Готовность мерчанта считается из Core Registry и доказательств A3 Pay, а не из технических ссылок провайдера или директории.",
  "a3PaySetup.merchantReadiness.emptyProvider": "Для этого мерчанта нет активного аккаунта Stripe или Klix.",
  "a3PaySetup.merchantReadiness.emptyRecipients": "Получатели расчетов и финансовые роли пока не связаны.",
  "a3PaySetup.merchantReadiness.eyebrow": "Готовность мерчанта",
  "a3PaySetup.merchantReadiness.gatesDescription": "Недостающие действия сгруппированы по ответственному владельцу.",
  "a3PaySetup.merchantReadiness.operations.lastFailed": "Последний неуспешный платеж",
  "a3PaySetup.merchantReadiness.operations.lastSuccessful": "Последний успешный платеж",
  "a3PaySetup.merchantReadiness.operations.openDisputes": "Открытые споры",
  "a3PaySetup.merchantReadiness.operations.openHolds": "Открытые удержания",
  "a3PaySetup.merchantReadiness.operations.riskCases": "Открытые risk cases",
  "a3PaySetup.merchantReadiness.paymentStatus.disabled": "Отключено",
  "a3PaySetup.merchantReadiness.paymentStatus.held": "Удержано",
  "a3PaySetup.merchantReadiness.paymentStatus.live": "Live",
  "a3PaySetup.merchantReadiness.paymentStatus.pending_review": "На проверке",
  "a3PaySetup.merchantReadiness.paymentStatus.sandbox": "Sandbox",
  "a3PaySetup.merchantReadiness.paymentStatus.suspended": "Приостановлено",
  "a3PaySetup.merchantReadiness.warningsLabel": "Предупреждения",
  "a3PaySetup.merchantReadiness.scope.latvia": "Связано с Латвией",
  "a3PaySetup.merchantReadiness.scope.noWallet": "Без кошелька или e-money",
  "a3PaySetup.merchantReadiness.scope.onlineOnly": "Только онлайн",
  "a3PaySetup.merchantReadiness.scope.volume": "Месячный объем",
  "a3PaySetup.merchantReadiness.sections.eventContext": "Контекст Event",
  "a3PaySetup.merchantReadiness.sections.missing": "Недостающие действия",
  "a3PaySetup.merchantReadiness.sections.missingDescription": "Выполнимые пробелы, сгруппированные по ответственному владельцу.",
  "a3PaySetup.merchantReadiness.sections.operations": "Операции",
  "a3PaySetup.merchantReadiness.sections.provider": "Адаптер провайдера",
  "a3PaySetup.merchantReadiness.sections.providerDescription": "Технические детали провайдера остаются в диагностике поддержки; здесь показана только готовность.",
  "a3PaySetup.merchantReadiness.sections.recipients": "Получатели расчетов",
  "a3PaySetup.merchantReadiness.sections.recipientsDescription": "Роли MerchantParty, которые могут получать выплаты или работать с финансовыми workflow.",
  "a3PaySetup.merchantReadiness.sections.scope": "Объем registered PI",
  "a3PaySetup.merchantReadiness.title": "Готовность мерчанта",
  "a3PaySetup.merchantReadiness.noMissing": "Недостающих действий нет.",
  "a3PaySetup.registry.actions.archive": "Архивировать",
  "a3PaySetup.registry.actions.cancelEdit": "Отменить редактирование",
  "a3PaySetup.registry.actions.createRecord": "Создать запись",
  "a3PaySetup.registry.actions.delete": "Удалить",
  "a3PaySetup.registry.actions.disable": "Отключить",
  "a3PaySetup.registry.actions.edit": "Редактировать",
  "a3PaySetup.registry.actions.editRecord": "Редактировать запись",
  "a3PaySetup.registry.actions.exportSnapshot": "Экспорт snapshot",
  "a3PaySetup.registry.actions.openReadiness": "Готовность",
  "a3PaySetup.registry.actions.restore": "Восстановить",
  "a3PaySetup.registry.actions.showDeleted": "Показать удаленные записи",
  "a3PaySetup.registry.description": "Просматривайте, редактируйте, удаляйте, восстанавливайте и экспортируйте платежные записи Core Registry.",
  "a3PaySetup.registry.empty": "В этом представлении пока нет записей.",
  "a3PaySetup.registry.eyebrow": "Core Registry Admin",
  "a3PaySetup.registry.formDescription": "Структурированные записи проходят через directory-контракты Core Registry с версией и audit evidence.",
  "a3PaySetup.registry.forms.country": "Страна",
  "a3PaySetup.registry.forms.currency": "Валюта",
  "a3PaySetup.registry.forms.displayName": "Название",
  "a3PaySetup.registry.forms.legalStatus": "Юридический статус",
  "a3PaySetup.registry.forms.methodProfile": "Профиль способов",
  "a3PaySetup.registry.forms.ownerParty": "Владеющая Party",
  "a3PaySetup.registry.forms.party": "Party",
  "a3PaySetup.registry.forms.partyOptional": "Party (необязательно)",
  "a3PaySetup.registry.forms.partyType": "Тип Party",
  "a3PaySetup.registry.forms.payoutEvidence": "Доказательство выплат",
  "a3PaySetup.registry.forms.phone": "Телефон",
  "a3PaySetup.registry.forms.product": "Product entitlement",
  "a3PaySetup.registry.forms.provider": "Провайдер",
  "a3PaySetup.registry.forms.providerPath": "Путь провайдера",
  "a3PaySetup.registry.forms.registeredAddress": "Юридический адрес",
  "a3PaySetup.registry.forms.registeredNumber": "Регистрационный номер",
  "a3PaySetup.registry.forms.role": "Роль",
  "a3PaySetup.registry.forms.safeAccountRef": "Безопасная ссылка аккаунта",
  "a3PaySetup.registry.forms.scope": "Scope",
  "a3PaySetup.registry.forms.scopeRecord": "Запись scope",
  "a3PaySetup.registry.forms.selectMerchant": "Выберите мерчанта",
  "a3PaySetup.registry.forms.selectParty": "Выберите Party",
  "a3PaySetup.registry.forms.selectScope": "Выберите запись scope",
  "a3PaySetup.registry.forms.timezone": "Часовой пояс",
  "a3PaySetup.registry.listDescription": "Статус, источник, версия и последняя синхронизация видны для licensing evidence.",
  "a3PaySetup.registry.notices.archive": "Запись архивирована.",
  "a3PaySetup.registry.notices.created": "Запись создана.",
  "a3PaySetup.registry.notices.delete": "Запись удалена, где возможно, иначе архивирована.",
  "a3PaySetup.registry.notices.deletedRecoverable": "Запись перенесена в удаленные. Включите \"Показать удаленные записи\", чтобы восстановить ее.",
  "a3PaySetup.registry.notices.disable": "Запись отключена.",
  "a3PaySetup.registry.notices.restored": "Запись восстановлена.",
  "a3PaySetup.registry.notices.snapshotReady": "Snapshot реестра подготовлен: {count} записей.",
  "a3PaySetup.registry.notices.updated": "Запись обновлена.",
  "a3PaySetup.registry.ownerLinked": "Владелец связан",
  "a3PaySetup.registry.ownerMissing": "Владелец отсутствует",
  "a3PaySetup.registry.safeRefMissing": "Безопасная ссылка отсутствует",
  "a3PaySetup.registry.safeRefRecorded": "Безопасная ссылка записана",
  "a3PaySetup.registry.tabs.access": "Доступ",
  "a3PaySetup.registry.tabs.accounts": "Аккаунты",
  "a3PaySetup.registry.tabs.entitlements": "Entitlements",
  "a3PaySetup.registry.tabs.memberships": "Memberships",
  "a3PaySetup.registry.tabs.merchants": "Мерчанты",
  "a3PaySetup.registry.tabs.parties": "Parties",
  "a3PaySetup.registry.title": "Реестр A3 Pay",
  "a3PaySetup.operations.header.description": "Workspace для платежей, защищенных средств, проверок и сопоставления платежей.",
  "a3PaySetup.operations.header.title": "Операции A3 Pay",
  "a3PaySetup.operations.disputes.description_one": "{count} спор требует внимания.",
  "a3PaySetup.operations.disputes.description_other": "{count} споров требуют внимания.",
  "a3PaySetup.operations.disputes.title": "Споры",
  "a3PaySetup.operations.payments.description_one": "{count} удержание платежа требует проверки.",
  "a3PaySetup.operations.payments.description_other": "{count} удержаний платежей требуют проверки.",
  "a3PaySetup.operations.payments.title": "Последние платежи",
  "a3PaySetup.operations.payouts.description": "Доступный баланс и статус следующей выплаты.",
  "a3PaySetup.operations.payouts.title": "Выплаты",
  "a3PaySetup.operations.reconciliation.description_one": "{count} проблема сопоставления платежа требует проверки.",
  "a3PaySetup.operations.reconciliation.description_other": "{count} проблем сопоставления платежей требуют проверки.",
  "a3PaySetup.operations.reconciliation.title": "Проблемы сопоставления платежей",
  "a3PaySetup.operations.refunds.description": "Запросы и история возвратов, где это разрешено.",
  "a3PaySetup.operations.refunds.title": "Возвраты",
  "a3PaySetup.operations.serviceAlerts.description_one": "{count} сервисное предупреждение требует внимания.",
  "a3PaySetup.operations.serviceAlerts.description_other": "{count} сервисных предупреждений требуют внимания.",
  "a3PaySetup.operations.serviceAlerts.title": "Сервисные предупреждения",
  "a3PaySetup.operations.summary.heldPayouts": "Удержанные выплаты",
  "a3PaySetup.operations.summary.matchingIssues": "Проблемы сопоставления",
  "a3PaySetup.operations.summary.openDisputes": "Открытые споры",
  "a3PaySetup.operations.summary.openReviews": "Открытые проверки",
  "a3PaySetup.operations.summary.paymentHolds": "Удержания платежей",
  "a3PaySetup.operations.summary.totalReviews": "Всего проверок",
  "a3PaySetup.operations.tabs.acquirer": "Терминальные расчеты",
  "a3PaySetup.operations.tabs.disputes": "Споры",
  "a3PaySetup.operations.tabs.ledger": "Защищенные средства",
  "a3PaySetup.operations.tabs.reconciliation": "Сопоставление платежей",
  "a3PaySetup.operations.tabs.remittance": "Выплаты",
  "a3PaySetup.operations.tabs.risk": "Проверки",
  "a3PaySetup.paymentAccounts.accountCard.a3PayCheckout": "Оплата через A3 Pay",
  "a3PaySetup.paymentAccounts.accountCard.a3PayNeedsSetup": "A3 Pay нужно настроить",
  "a3PaySetup.paymentAccounts.accountCard.a3PayNotEnabled": "A3 Pay не включен",
  "a3PaySetup.paymentAccounts.accountCard.a3PayReady": "A3 Pay готов",
  "a3PaySetup.paymentAccounts.accountCard.directTableServicePayments": "Прямые платежи Table Service",
  "a3PaySetup.paymentAccounts.accountCard.merchantPaymentSetup": "Настройка платежей мерчанта",
  "a3PaySetup.paymentAccounts.accountCard.klixNotConnected": "Klix не подключен",
  "a3PaySetup.paymentAccounts.accountCard.klixReady": "Klix готов",
  "a3PaySetup.paymentAccounts.accountCard.liveReady": "Готово к live",
  "a3PaySetup.paymentAccounts.accountCard.noProviderAccount": "Для этого мерчанта еще не импортирован аккаунт провайдера.",
  "a3PaySetup.paymentAccounts.accountCard.paymentAccount": "Платежный аккаунт",
  "a3PaySetup.paymentAccounts.accountCard.stripeDirectNotConnected": "Stripe direct не подключен",
  "a3PaySetup.paymentAccounts.accountCard.stripeDirectReady": "Stripe direct готов",
  "a3PaySetup.paymentAccounts.accountStatus.readyForA3Pay": "Готово для A3 Pay",
  "a3PaySetup.paymentAccounts.accountStatus.sandboxCheckoutReady": "Тестовая оплата готова",
  "a3PaySetup.paymentAccounts.accountStatus.stripeDirectAvailable": "Stripe direct доступен",
  "a3PaySetup.paymentAccounts.capability.cardPresentEvidence": "Терминальный/card-present платеж через лицензированного эквайера",
  "a3PaySetup.paymentAccounts.capability.bnpl": "Pay Later / BNPL",
  "a3PaySetup.paymentAccounts.capability.disputes": "Споры",
  "a3PaySetup.paymentAccounts.capability.hostedCheckout": "Hosted checkout",
  "a3PaySetup.paymentAccounts.capability.latviaBankPis": "Латвийские bank/PIS методы",
  "a3PaySetup.paymentAccounts.capability.methodWhitelist": "Нужен whitelist методов",
  "a3PaySetup.paymentAccounts.capability.onlineCard": "Онлайн-карта",
  "a3PaySetup.paymentAccounts.capability.reconciliationFiles": "Файлы сверки",
  "a3PaySetup.paymentAccounts.capability.refunds": "Возвраты",
  "a3PaySetup.paymentAccounts.capability.transfers": "Переводы",
  "a3PaySetup.paymentAccounts.capability.wallets": "Кошельки",
  "a3PaySetup.paymentAccounts.channels.description": "Активные каналы остаются привязаны к мерчанту и доказательствам.",
  "a3PaySetup.paymentAccounts.channels.needsProvider": "Нужен провайдер",
  "a3PaySetup.paymentAccounts.channels.offPendingSignoff": "Выключено до подтверждения",
  "a3PaySetup.paymentAccounts.channels.title": "Каналы",
  "a3PaySetup.paymentAccounts.configure.adapterKlix": "Адаптер: Klix hosted purchase с whitelist латвийских bank/PIS методов",
  "a3PaySetup.paymentAccounts.configure.adapterStripe": "Адаптер: онлайн-платежи Stripe",
  "a3PaySetup.paymentAccounts.configure.description": "A3 Pay управляет выбором hosted provider для Table Service. Stripe и Klix настраиваются здесь; raw refs остаются в диагностике.",
  "a3PaySetup.paymentAccounts.configure.findMerchant": "Найти мерчанта",
  "a3PaySetup.paymentAccounts.configure.findMerchantPlaceholder": "Поиск по точке, стране, валюте или статусу",
  "a3PaySetup.paymentAccounts.configure.klixMethodProfile": "Профиль методов Klix: только латвийские bank/PIS",
  "a3PaySetup.paymentAccounts.configure.klixMethodProfileDescription": "Карты, кошельки, Pay Later/BNPL и неутвержденные cross-border методы остаются выключены до отдельного подтверждения.",
  "a3PaySetup.paymentAccounts.configure.noMerchantMatches": "Подходящих мерчантов нет",
  "a3PaySetup.paymentAccounts.configure.noProviderAccounts": "Для этого мерчанта нет импортированных аккаунтов {provider}",
  "a3PaySetup.paymentAccounts.configure.noStripeAccounts": "Для этого мерчанта нет импортированных Stripe-аккаунтов",
  "a3PaySetup.paymentAccounts.configure.provider": "Провайдер",
  "a3PaySetup.paymentAccounts.configure.providerAccount": "Аккаунт провайдера",
  "a3PaySetup.paymentAccounts.configure.providerAccountHint": "Выберите импортированный аккаунт провайдера или сначала обновите данные аккаунтов.",
  "a3PaySetup.paymentAccounts.configure.providerKlix": "Klix",
  "a3PaySetup.paymentAccounts.configure.providerStripe": "Stripe",
  "a3PaySetup.paymentAccounts.configure.selectedProviderAccount": "{account} выбран для платежей Table Service.",
  "a3PaySetup.paymentAccounts.configure.selectedStripeAccount": "{account} выбран для платежей Table Service.",
  "a3PaySetup.paymentAccounts.configure.stripeAccount": "Аккаунт Stripe",
  "a3PaySetup.paymentAccounts.configure.stripeAccountPlaceholder": "acct_...",
  "a3PaySetup.paymentAccounts.configure.title": "Прием платежей",
  "a3PaySetup.paymentAccounts.empty.description": "Импортируйте данные Product Directory, чтобы показать здесь готовность мерчантов и статус аккаунтов провайдера.",
  "a3PaySetup.paymentAccounts.empty.title": "Платежные аккаунты еще не импортированы",
  "a3PaySetup.paymentAccounts.header.badge": "Настройка платежей для нескольких мерчантов",
  "a3PaySetup.paymentAccounts.header.description": "Посмотрите, какие мерчанты могут принимать платежи A3 Pay и какие точки могут продолжать использовать Stripe direct через Table Service.",
  "a3PaySetup.paymentAccounts.header.title": "Платежные аккаунты",
  "a3PaySetup.paymentAccounts.loadedCount": "Загружено: {count}",
  "a3PaySetup.paymentAccounts.loading": "Загрузка платежных аккаунтов",
  "a3PaySetup.paymentAccounts.missingSetupTitle": "Некоторым мерчантам нужна настройка перед live-оплатой через A3 Pay",
  "a3PaySetup.paymentAccounts.providers.description": "Настройка провайдера отделена от способов оплаты, которые мерчант может предложить.",
  "a3PaySetup.paymentAccounts.providers.accounts": "{count} аккаунтов",
  "a3PaySetup.paymentAccounts.providers.allowedMethods": "Разрешено: {methods}",
  "a3PaySetup.paymentAccounts.providers.disabledMethods": "Выключено: {methods}",
  "a3PaySetup.paymentAccounts.providers.liveReady": "{count} готовы к live",
  "a3PaySetup.paymentAccounts.providers.methodProfile": "Профиль методов",
  "a3PaySetup.paymentAccounts.providers.sandboxReady": "{count} готовы к sandbox",
  "a3PaySetup.paymentAccounts.providers.title": "Провайдеры и способы",
  "a3PaySetup.paymentAccounts.readiness.description": "Статус аккаунта остается понятным для мерчанта, чтобы видеть готовность без чтения технических данных провайдера.",
  "a3PaySetup.paymentAccounts.readiness.title": "Готовность мерчанта",
  "a3PaySetup.paymentAccounts.status.disabled": "Выключено",
  "a3PaySetup.paymentAccounts.status.planned": "Планируется",
  "a3PaySetup.paymentAccounts.status.ready": "Готово",
  "a3PaySetup.paymentAccounts.status.setupNeeded": "Нужна настройка",
  "a3PaySetup.paymentAccounts.summary.a3PayReady": "A3 Pay готов",
  "a3PaySetup.paymentAccounts.summary.canCreateSandbox": "{count} могут создать тестовые сессии",
  "a3PaySetup.paymentAccounts.summary.enabledForA3Pay": "{count} включены для A3 Pay",
  "a3PaySetup.paymentAccounts.summary.merchants": "Мерчанты",
  "a3PaySetup.paymentAccounts.summary.needsSetup": "Нужна настройка",
  "a3PaySetup.paymentAccounts.summary.stripeDirect": "Stripe direct",
  "a3PaySetup.paymentAccounts.summary.updatedAt": "Обновлено {value}",
  "a3PaySetup.paymentAccounts.summary.withoutA3Pay": "{count} без A3 Pay",
  "a3PaySetup.production.evidence.description": "Сформировать датированный пакет для Latvijas Banka с готовностью, реестром, ролями/доступом и offline demo исходной системы.",
  "a3PaySetup.production.evidence.generatePackage": "Сформировать пакет доказательств",
  "a3PaySetup.production.evidence.preLicensingSnapshot": "Снимок готовности перед лицензированием",
  "a3PaySetup.production.evidence.preLicensingSnapshotDetail": "Прикладываемые релизные проверки, runbook-документы, флаги неподдерживаемых каналов и production-счётчики.",
  "a3PaySetup.production.evidence.registrySnapshot": "Снимок Core Registry",
  "a3PaySetup.production.evidence.roleAccessExport": "Экспорт проверки ролей/доступа",
  "a3PaySetup.production.evidence.roleAccessExportDetail": "В пакет включены продуктовые роли, изменения доступа и решения maker/checker.",
  "a3PaySetup.production.evidence.standaloneBundle": "Первый пакет с offline исходной системой",
  "a3PaySetup.production.evidence.title": "Доказательства для лицензирования",
  "a3PaySetup.production.header.description": "Релизные проверки для режима чтения, перевода мерчантов, резервных копий и изоляции провайдера. Запуск на уровне мерчанта без раскрытия внутренних деталей исходной системы.",
  "a3PaySetup.production.header.title": "Готовность к production",
  "a3PaySetup.production.runtime.actualDatabase": "Фактическая база данных",
  "a3PaySetup.production.runtime.databaseBoundaryChecked": "Граница базы данных проверена",
  "a3PaySetup.production.runtime.databaseBoundaryNotChecked": "Граница базы данных не проверена",
  "a3PaySetup.production.runtime.description": "Несекретные настройки релиза",
  "a3PaySetup.production.runtime.expectedDatabase": "Ожидаемая база данных",
  "a3PaySetup.production.runtime.paymentCutover": "Перевод платежей",
  "a3PaySetup.production.runtime.restoreEvidence": "Доказательство восстановления",
  "a3PaySetup.production.runtime.settlementCutover": "Перевод выплат",
  "a3PaySetup.production.runtime.title": "Runtime",
  "a3PaySetup.production.sections.isolation.description": "A3 Pay может работать без внутренних данных исходной системы",
  "a3PaySetup.production.sections.isolation.title": "Изоляция",
  "a3PaySetup.production.sections.operations.accounts": "Аккаунты",
  "a3PaySetup.production.sections.operations.blockedPayments": "Заблокированные платежи",
  "a3PaySetup.production.sections.operations.cutoverRefs": "Ссылки перевода",
  "a3PaySetup.production.sections.operations.description": "Актуальные доказательства для решения",
  "a3PaySetup.production.sections.operations.merchants": "Мерчанты",
  "a3PaySetup.production.sections.operations.openWork": "Открытая работа",
  "a3PaySetup.production.sections.operations.settlementIssues": "Проблемы выплат",
  "a3PaySetup.production.sections.operations.title": "Операции",
  "a3PaySetup.production.sections.releaseGates.description": "Текущее решение для этого rollout scope A3 Pay",
  "a3PaySetup.production.sections.releaseGates.title": "Релизные проверки",
  "a3PaySetup.production.sections.runbooks.approved": "Runbook утверждены",
  "a3PaySetup.production.sections.runbooks.description": "Резервные копии, инциденты, сверка и review доступа готовы до cutover",
  "a3PaySetup.production.sections.runbooks.filesPresent": "{ready}/{total} файлов доступны",
  "a3PaySetup.production.sections.runbooks.title": "Runbooks",
  "a3PaySetup.production.sections.scope.channel": "Канал",
  "a3PaySetup.production.sections.scope.description": "Контекст проверок мерчанта и канала",
  "a3PaySetup.production.sections.scope.directoryMerchant": "Мерчант в директории",
  "a3PaySetup.production.sections.scope.title": "Scope",
  "a3PaySetup.production.sections.standaloneDemo.description": "Table Service и A3 Pay работают, когда исходная система недоступна",
  "a3PaySetup.production.sections.standaloneDemo.evidenceRecorded": "Доказательство записано",
  "a3PaySetup.production.sections.standaloneDemo.latestEvidence": "Последнее доказательство",
  "a3PaySetup.production.sections.standaloneDemo.latestEvidenceRecorded": "{date} · доказательство записано",
  "a3PaySetup.production.sections.standaloneDemo.sourceOffline": "Демо платежа при недоступной исходной системе",
  "a3PaySetup.production.sections.standaloneDemo.title": "Standalone demo",
  "a3PaySetup.production.status.blocked": "Заблокировано",
  "a3PaySetup.production.status.needsReview": "Нужна проверка",
  "a3PaySetup.production.summary.environment": "Окружение",
  "a3PaySetup.production.summary.isolation": "Изоляция",
  "a3PaySetup.production.summary.onSiteRemittance": "On-site выплаты",
  "a3PaySetup.production.summary.providerActions": "Действия провайдера",
  "a3PaySetup.production.summary.releaseGate": "Релизная проверка",
  "a3PaySetup.production.summary.uiMode": "Режим UI",
  "a3PaySetup.receipts.automatic.futureA3Pay": "Автоматически отправлять чеки для будущих платежей A3 Pay.",
  "a3PaySetup.receipts.automatic.recognized": "Автоматически отправлять чеки, когда A3 Pay меня узнает.",
  "a3PaySetup.receipts.emailAlreadySaved": "Email для чека уже сохранен для этого платежа: {email}",
  "a3PaySetup.receipts.emailOptional": "Email необязателен. Он используется только для этого чека, если вы не включите автоматические чеки.",
  "a3PaySetup.receipts.emailOptionalNotice": "Email необязателен. Добавьте его только если хотите получить чек по email.",
  "a3PaySetup.receipts.emailReceipt": "Чек по email",
  "a3PaySetup.receipts.includeMerchantOffers": "Добавлять предложения мерчанта, когда они доступны.",
  "a3PaySetup.receipts.includeMerchantOffersWhenAvailable": "Добавлять одобренные мерчантом предложения, когда они доступны.",
  "a3PaySetup.receipts.paymentCompleteAwaitingFiscal": "Платеж завершен. Фискальный чек еще готовится, поэтому email будет отправлен позже.",
  "a3PaySetup.receipts.preferenceEmail": "Email чека",
  "a3PaySetup.receipts.settingsActionNotMine": "Ниже можно остановить эти чеки.",
  "a3PaySetup.receipts.settingsActionPromoOptOut": "Ниже можно выключить предложения мерчанта.",
  "a3PaySetup.receiptTemplates.active": "Активные",
  "a3PaySetup.receiptTemplates.description": "Шаблоны отправителя и локали мерчанта",
  "a3PaySetup.receiptTemplates.from": "От",
  "a3PaySetup.receiptTemplates.noTemplates": "Шаблонов нет.",
  "a3PaySetup.receiptTemplates.preview": "Предпросмотр",
  "a3PaySetup.receiptTemplates.receiptTemplateActivated": "Шаблон чека активирован.",
  "a3PaySetup.receiptTemplates.receiptTemplateRolledBack": "Шаблон чека откатан.",
  "a3PaySetup.receiptTemplates.receiptTemplateSaved": "Шаблон чека сохранен.",
  "a3PaySetup.receiptTemplates.template": "Шаблон",
  "a3PaySetup.receiptTemplates.title": "Шаблоны чеков",
  "a3PaySetup.sections.diagnostics.description": "Для поддержки, финансов и compliance troubleshooting. Технические ссылки провайдера, событий и доказательств остаются здесь.",
  "a3PaySetup.sections.diagnostics.title": "Расширенная диагностика",
  "a3PaySetup.sections.evidence.description": "Планшетный и desktop-вид для финансовых, support и сверочных проверок. Настройка остается основным сценарием.",
  "a3PaySetup.sections.evidence.title": "Доказательства и сверка",
  "a3PaySetup.sections.operations.description": "Ежедневные платежные операции отделены от первичной настройки.",
  "a3PaySetup.sections.operations.title": "Ежедневные платежные операции",
  "a3PaySetup.sections.setup.description": "Пройдите шесть проверок, которые определяют, может ли точка принимать оплату счетов Table Service.",
  "a3PaySetup.sections.setup.title": "Чеклист настройки",
  "a3PaySetup.status.available": "Доступно",
  "a3PaySetup.status.needsReview": "Нужна проверка",
  "a3PaySetup.status.needsSetup": "Нужна настройка",
  "a3PaySetup.status.ready": "Готово",
  "a3PaySetup.status.underReview": "На проверке",
  "a3PaySetup.status.waiting": "Ожидание",
  "a3PaySetup.evidence.columns.action": "Действие",
  "a3PaySetup.evidence.columns.area": "Область",
  "a3PaySetup.evidence.columns.metric": "Метрика",
  "a3PaySetup.evidence.columns.status": "Статус",
  "a3PaySetup.evidence.desktopOnly": "Детальная проверка доказательств и действия уровня экспорта доступны на планшете или desktop.",
  "a3PaySetup.evidence.paymentMatching.detail": "Открытые проблемы сверки по доказательствам провайдера и терминальных расчетов.",
  "a3PaySetup.evidence.paymentMatching.title": "Сопоставление платежей",
  "a3PaySetup.evidence.payoutInstructions.detail": "Удержанные или неуспешные входящие инструкции по выплатам.",
  "a3PaySetup.evidence.payoutInstructions.title": "Инструкции по выплатам",
  "a3PaySetup.evidence.protectedFunds.detail": "Доступный защищенный баланс до исполнения выплаты.",
  "a3PaySetup.evidence.protectedFunds.title": "Защищенные средства",
  "a3PaySetup.evidence.providerUpdates.detail": "Удержания платежей и предупреждения обновлений провайдера.",
  "a3PaySetup.evidence.providerUpdates.title": "Обновления провайдера",
  "a3PaySetup.evidence.tableLabel": "Проверка доказательств и сверки",
  "a3PaySetup.evidence.terminalSettlement.detail": "Доказательства терминалов лицензированного эквайера с открытыми расхождениями.",
  "a3PaySetup.evidence.terminalSettlement.title": "Терминальные расчеты",
  "a3PaySetup.statusPage.checkingPayment": "Проверка платежа",
  "a3PaySetup.statusPage.latestUpdate": "Последнее событие",
  "a3PaySetup.statusPage.merchant": "Мерчант",
  "a3PaySetup.statusPage.paymentStatus": "Статус платежа",
  "a3PaySetup.statusPage.recentUpdates": "Последние обновления",
  "a3PaySetup.statusPage.title": "Статус платежа",
  "a3PaySetup.steps.businessProfile.detail": "Подтвердите профиль бизнеса и идентичность точки для приема платежей.",
  "a3PaySetup.steps.businessProfile.title": "Профиль бизнеса",
  "a3PaySetup.steps.methods.detail": "Выберите онлайн и терминальные/card-present способы, которыми смогут платить гости.",
  "a3PaySetup.steps.methods.title": "Способы оплаты",
  "a3PaySetup.steps.payouts.detail": "Проверьте статус выплат и сопоставление платежей до отправки средств.",
  "a3PaySetup.steps.payouts.title": "Выплаты и сверка",
  "a3PaySetup.steps.provider.detail": "Подключите аккаунт провайдера для приема гостевых платежей.",
  "a3PaySetup.steps.provider.title": "Платежный провайдер",
  "a3PaySetup.steps.receipts.detail": "Настройте email-чек и шаблоны, где это включено.",
  "a3PaySetup.steps.receipts.title": "Чеки и email",
  "a3PaySetup.steps.tableService.detail": "Проверьте, что счета A3 Table Service могут создавать гостевой платеж.",
  "a3PaySetup.steps.tableService.title": "Подключение Table Service",
  "a3PaySetup.summary.description": "Принимайте онлайн и терминальные/card-present платежи по счетам Table Service.",
  "a3PaySetup.summary.launchState.actionNeeded": "Нужно действие",
  "a3PaySetup.summary.launchState.checkingSetup": "Проверка настройки",
  "a3PaySetup.summary.launchState.paymentsPaused": "Платежи остановлены",
  "a3PaySetup.summary.launchState.payoutSetupRequired": "Нужна настройка выплат",
  "a3PaySetup.summary.launchState.providerSetupRequired": "Нужна настройка провайдера",
  "a3PaySetup.summary.launchState.readyForOnlinePayments": "Готово принимать онлайн-платежи",
  "a3PaySetup.summary.launchState.readyToTest": "Готово к тесту",
  "a3PaySetup.summary.launchState.serviceIssue": "Проблема сервиса",
  "a3PaySetup.summary.launchState.underReview": "На проверке",
  "a3PaySetup.summary.nextAction": "Дальше: {action}",
  "a3PaySetup.summary.nextActionReady": "Платежи готовы.",
  "a3PaySetup.summary.progress": "{ready} из {total} шагов готовы",
  "a3PaySetup.summary.title": "Настройка A3 Pay",
  "a3PaySetup.diagnostics.providerAccounts.detail": "Технический статус аккаунта провайдера и импортированные ссылки аккаунта.",
  "a3PaySetup.diagnostics.providerAccounts.title": "Аккаунты провайдера",
  "a3PaySetup.diagnostics.providerUpdates.detail": "Состояние обновлений провайдера и задержка платежных событий.",
  "a3PaySetup.diagnostics.providerUpdates.title": "Обновления провайдера",
  "a3PaySetup.diagnostics.payoutInstructions.detail": "Ссылки инструкций выплат, удержания и ошибки intake выплат.",
  "a3PaySetup.diagnostics.payoutInstructions.title": "Инструкции выплат",
  "a3PaySetup.diagnostics.terminalSettlement.detail": "Терминальные/card-present доказательства от расчетов лицензированного эквайера.",
  "a3PaySetup.diagnostics.terminalSettlement.title": "Терминальные расчеты",
  "a3PaySetup.trace.availableFunds": "Доступные средства",
  "a3PaySetup.trace.dailyPayouts": "Дневные выплаты",
  "a3PaySetup.trace.dailyResiduals": "Дневные остатки",
  "a3PaySetup.trace.header.badge": "Трассировка операций",
  "a3PaySetup.trace.header.description": "Support и finance могут пройти цепочку: исходная формула -> неизменный план -> инструкция выплаты -> выплата без внешней админки.",
  "a3PaySetup.trace.header.title": "Отследить платеж",
  "a3PaySetup.trace.heldSettlements": "Удержанные выплаты",
  "a3PaySetup.trace.immutablePlan.detail": "Ссылка и hash плана связывают суммы получателей с доказательствами источника.",
  "a3PaySetup.trace.immutablePlan.title": "Неизменный план",
  "a3PaySetup.trace.eventEvidence.detail": "Данные Event хранятся только как доказательство источника; A3 Pay не владеет правилами распределения Event.",
  "a3PaySetup.trace.eventEvidence.sourceOnly": "Только доказательство источника",
  "a3PaySetup.trace.eventEvidence.title": "Доказательства Event",
  "a3PaySetup.trace.eventRef": "Ссылка Event",
  "a3PaySetup.trace.eventSnapshot": "Hash snapshot Event",
  "a3PaySetup.trace.fiscalEvidence.detail": "Фискальные ссылки и артефакты поставляет A3 Venue Bridge или A3 Fiscal Register.",
  "a3PaySetup.trace.fiscalEvidence.title": "Фискальные доказательства",
  "a3PaySetup.trace.fiscalIntent": "Фискальный intent",
  "a3PaySetup.trace.fiscalOwner": "Фискальный владелец",
  "a3PaySetup.trace.fiscalRef": "Фискальная ссылка",
  "a3PaySetup.trace.latestEvent": "Последнее событие",
  "a3PaySetup.trace.links.paymentAcceptance": "Прием платежей и провайдеры",
  "a3PaySetup.trace.links.protectedRemittance": "Выплаты защищенных средств",
  "a3PaySetup.trace.links.reconciliationBreaks": "Проблемы сопоставления платежей",
  "a3PaySetup.trace.openBreaks": "Открытые расхождения",
  "a3PaySetup.trace.openReviews": "Открытые проверки",
  "a3PaySetup.trace.merchantEvidence.detail": "Доказательства мерчанта и владельца показаны без raw directory payloads.",
  "a3PaySetup.trace.merchantEvidence.title": "Мерчант и владелец",
  "a3PaySetup.trace.merchantSnapshot": "Snapshot мерчанта",
  "a3PaySetup.trace.ownerParty": "Владелец Party",
  "a3PaySetup.trace.ownerSnapshot": "Snapshot владельца",
  "a3PaySetup.trace.paymentEvents.detail": "Статус провайдера виден без чтения технических payload провайдера.",
  "a3PaySetup.trace.paymentEvents.title": "Платежный запрос и события",
  "a3PaySetup.trace.paymentHolds": "Удержания платежей",
  "a3PaySetup.trace.paymentStatus": "Статус платежа",
  "a3PaySetup.trace.planHash": "Hash плана",
  "a3PaySetup.trace.planRef": "Ссылка плана",
  "a3PaySetup.trace.profileVersion": "Версия профиля",
  "a3PaySetup.trace.provider": "Провайдер",
  "a3PaySetup.trace.providerMode": "Режим провайдера",
  "a3PaySetup.trace.providerSession": "Hosted session",
  "a3PaySetup.trace.queueItems": "Элементы очереди",
  "a3PaySetup.trace.reason": "Причина",
  "a3PaySetup.trace.recipientTotal": "Итого получателям",
  "a3PaySetup.trace.relatedPayouts": "Связанные выплаты",
  "a3PaySetup.trace.riskHolds": "Удержания по рискам",
  "a3PaySetup.trace.safeguardedFunds.detail": "Средства сгруппированы по исходному кредиту, мерчанту и каналу.",
  "a3PaySetup.trace.safeguardedFunds.title": "Защищенные средства",
  "a3PaySetup.trace.sent": "Отправлено",
  "a3PaySetup.trace.settlementInstruction.created": "Создано",
  "a3PaySetup.trace.settlementInstruction.detail": "A3 Pay может принять, удержать или отклонить без изменения правил источника.",
  "a3PaySetup.trace.settlementInstruction.instruction": "Инструкция",
  "a3PaySetup.trace.settlementInstruction.title": "Инструкция выплаты",
  "a3PaySetup.trace.sourceFormula.detail": "Исходная система владеет правилами получателей и доказательствами расчета.",
  "a3PaySetup.trace.sourceFormula.a3PayFormula": "Без формулы A3 Pay",
  "a3PaySetup.trace.sourceFormula.owner": "Владелец",
  "a3PaySetup.trace.sourceFormula.sourceManagedCopy": "В режиме source-managed владельцем остается исходная система. В standalone режиме управление остается за A3 Table Service. A3 Pay не рассчитывает формулы.",
  "a3PaySetup.trace.sourceFormula.sourceRef": "Ссылка источника",
  "a3PaySetup.trace.sourceFormula.title": "Формула источника",
  "a3PaySetup.trace.sourceOwner.coopPlatform": "Управляется исходной платформой",
  "a3PaySetup.trace.sourceOwner.notRecorded": "Исходная система не записана",
  "a3PaySetup.trace.sourceOwner.tableServiceStandalone": "Управляется A3 Table Service standalone",
  "a3PaySetup.trace.status.needsEvidence": "Нужны доказательства",
  "a3PaySetup.trace.status.ready": "Готово",
  "a3PaySetup.trace.remittance.detail": "Выплаты, удержания и проблемы сопоставления платежей отслеживаются в одном workspace.",
  "a3PaySetup.trace.remittance.title": "Выплаты и сопоставление платежей",
};

export default a3PaySetupRu;
